import type { CSSProperties } from "react";

/**
 * The site palette.
 *
 * This used to redeclare every theme token on the public pages' wrapper, while
 * the app stayed navy. The whole product now uses the same green-black palette
 * and `index.css` is its only source, so this is empty. It is kept so the many
 * `style={HOME_THEME}` call sites keep working; they no longer change anything.
 */
export const HOME_THEME = {} as CSSProperties;

export const MONO = "'Geist Mono', ui-monospace, SFMono-Regular, monospace";
export const SANS = "'Geist', 'Geist Fallback', 'Manrope', system-ui, sans-serif";
